/**
 * Helper utilities
 */

export const formatCurrency = (amount: number): string => {
  const value = Number(amount || 0);

  return value % 1 === 0
    ? `£${value}`
    : `£${value.toFixed(2)}`;
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const getDateRange = (range: '7d' | '30d' | 'all'): { from: string; to: string } => {
  const to = new Date();
  let from = new Date();

  switch (range) {
    case '7d':
      from.setDate(to.getDate() - 7);
      break;
    case '30d':
      from.setDate(to.getDate() - 30);
      break;
    case 'all':
      from = new Date(0); // Unix epoch
      break;
  }

  return {
    from: from.toISOString().split('T')[0],
    to: to.toISOString().split('T')[0],
  };
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
